import { createTutorialGuidePages } from './tutorialGuidePages';
import { createFeatureGuidePages } from './featureGuidePages';

const tutorialLinks = [
  { href: '/tutorials/install/', text: 'How to install GB WhatsApp APK safely' },
  { href: '/tutorials/update/', text: 'How to update GB WhatsApp without losing chats' },
  { href: '/tutorials/backup/', text: 'How to backup and restore GB WhatsApp chats' },
  { href: '/tutorials/verification/', text: 'How to fix GB WhatsApp verification code issues' },
  { href: '/tutorials/ban/', text: 'How to avoid getting banned on GB WhatsApp' },
  { href: '/tutorials/transfer/', text: 'How to transfer WhatsApp data to GB WhatsApp' },
];

// 导航栏 Tutorials 下拉菜单（精炼文案）
export const tutorialNavLinks = [
  { href: '/tutorials/install/', text: 'Install Guide' },
  { href: '/tutorials/update/', text: 'Update Guide' },
  { href: '/tutorials/backup/', text: 'Backup & Restore' },
  { href: '/tutorials/verification/', text: 'Fix Verification' },
  { href: '/tutorials/ban/', text: 'Ban Prevention' },
  { href: '/tutorials/transfer/', text: 'Transfer Data' },
];

// 导航栏 Features 下拉菜单（精炼文案）
export const featureNavLinks = [
  { href: '/features/hide-online/', text: 'Hide Online' },
  { href: '/features/anti-delete/', text: 'Anti Delete' },
  { href: '/features/themes/', text: 'Custom Themes' },
  { href: '/features/dual-whatsapp/', text: 'Dual WhatsApp' },
];

// 页脚 Legal 链接
export const legalNavLinks = [
  { href: '/about-us/', text: 'About Us' },
  { href: '/contact-us/', text: 'Contact Us' },
  { href: '/privacy-policy/', text: 'Privacy Policy' },
  { href: '/terms-conditions/', text: 'Terms & Conditions' },
  { href: '/disclaimer/', text: 'Disclaimer' },
];

const featureLinks = [
  { href: '/features/hide-online/', text: 'How to hide online status in GB WhatsApp' },
  { href: '/features/anti-delete/', text: 'How to read deleted messages in GB WhatsApp' },
  { href: '/features/themes/', text: 'How to customize GB WhatsApp themes' },
  { href: '/features/dual-whatsapp/', text: 'How to use dual WhatsApp on one phone' },
];

// 全站内链长尾锚文本（符合建站文档 SEO 规则）
const internalLinkLabels = {
  ...Object.fromEntries(tutorialLinks.map((link) => [link.href, link.text])),
  ...Object.fromEntries(featureLinks.map((link) => [link.href, link.text])),
  '/download/': 'Download GB WhatsApp APK latest version safely',
  '/tutorials/': 'Explore complete GB WhatsApp tutorials and guides',
};

function buildPageLinks(hrefs) {
  return hrefs.map((href) => ({
    href,
    text: internalLinkLabels[href] || href,
  }));
}

function makeGuide(title, intro, sections, navPage = 'tutorials', relatedHrefs = []) {
  const isFeatures = navPage === 'features';
  return {
    navPage,
    isGuide: true,
    guideBadge: isFeatures ? 'Feature Guide' : 'Step-by-Step Tutorial',
    breadcrumbParent: isFeatures
      ? { href: '/features/', label: 'Features' }
      : { href: '/tutorials/', label: 'Tutorials' },
    breadcrumbLabel: title.replace(/\s*\(.*$/, '').replace(/^How to /i, ''),
    title,
    intro,
    sections: sections.map((heading, index) => ({
      heading,
      step: String(index + 1).padStart(2, '0'),
      body: [
        `${heading} matters because most GB WhatsApp problems happen before users notice the small setup details. Start by checking your Android version, storage space, current chat backup, and whether your phone can receive SMS or calls normally.`,
        `Use a calm step-by-step process instead of reinstalling repeatedly. Repeated attempts can create duplicate folders, broken backups, or extra verification checks. If something fails, write down the exact error message first, then fix that specific cause.`,
        index % 2 === 0
          ? 'For safer results, keep one recent local backup, avoid unknown APK mirrors, and use the same phone number during setup. This protects your chats and reduces the chance of losing media during updates or transfers.'
          : 'If the issue continues, test with a stable network, restart the device, and confirm that battery optimization is not blocking background activity. Many delays and notification issues come from Android restrictions rather than the app itself.',
      ],
    })),
    relatedLinks: relatedHrefs.length ? buildPageLinks(relatedHrefs) : [],
  };
}

export const sitePages = {
  '/download/': {
    navPage: 'download',
    title: 'Download GB WhatsApp APK Latest Version',
    intro: 'Get the latest GB WhatsApp APK details, safety reminders, and installation path before downloading.',
    heroCta: {
      text: 'Download GB WhatsApp APK',
      download: true,
    },
    sections: [
      {
        heading: 'Before You Download',
        body: [
          {
            parts: [
              { text: 'GB WhatsApp', href: '/' },
              { text: ' is not available on Google Play, so the download process depends on APK installation. Users should check the version, file size, Android compatibility, and source reliability before installing anything.' },
            ],
          },
          'The safest approach is to create a chat backup first, keep your phone charged, and avoid downloading multiple APK copies from random pages. A clean single download is easier to verify and troubleshoot.',
        ],
      },
      {
        heading: 'Latest Version App Info',
        body: [
          'Get all the essential details about GB WhatsApp Mod APK.',
          'Safe, secure, and packed with powerful features.',
        ],
        table: [
          ['App', 'GB WhatsApp'],
          ['Type', 'WhatsApp Mod APK'],
          ['Platform', 'Android'],
          ['File', 'APK'],
          ['Update', 'Latest Version'],
          ['Status', 'Anti-Ban 2026'],
          ['Focus Area', 'Privacy, themes, media sharing, chat tools'],
        ],
      },
      {
        heading: 'Download Safety Tips',
        body: [
          'Do not install an APK if the file name, permissions, or size looks suspicious. Avoid pages that force extra apps, browser extensions, or unrelated downloads.',
          'After installation, review permissions and test the app with normal messaging behavior first. Do not use your most important account until you are comfortable with the risks.',
        ],
      },
    ],
  },
  '/tutorials/': {
    navPage: 'tutorials',
    title: 'GB WhatsApp Tutorials - Install, Update, Backup & Fix Guide',
    intro: 'Explore complete GB WhatsApp tutorials including installation, update, backup, verification fix, ban prevention, and data transfer guides. Step-by-step solutions for all common issues.',
    sections: [
      {
        heading: 'What You Can Learn in This GB WhatsApp Tutorial Hub',
        body: [
          'This tutorial hub is built for users who want practical answers, not vague app descriptions. You can find help for GB WhatsApp installation, updates, backups, OTP verification, ban prevention, and chat transfer in one place.',
          'Each guide focuses on the real moment where users get stuck: blocked installation permissions, missing SMS codes, fear of losing chats, version mismatch warnings, and confusion about where backups are stored.',
        ],
      },
      { heading: 'Install GB WhatsApp Guide', body: ['Follow this guide when you need a focused walkthrough. It explains the required checks, safe order of steps, common mistakes, and when you should stop and back up before continuing.'], cta: tutorialLinks[0] },
      { heading: 'Update GB WhatsApp Safely', body: ['Follow this guide when you need a focused walkthrough. It explains the required checks, safe order of steps, common mistakes, and when you should stop and back up before continuing.'], cta: tutorialLinks[1] },
      { heading: 'Backup & Restore Chats', body: ['Follow this guide when you need a focused walkthrough. It explains the required checks, safe order of steps, common mistakes, and when you should stop and back up before continuing.'], cta: tutorialLinks[2] },
      { heading: 'Fix Verification Issues', body: ['Follow this guide when you need a focused walkthrough. It explains the required checks, safe order of steps, common mistakes, and when you should stop and back up before continuing.'], cta: tutorialLinks[3] },
      { heading: 'Avoid Getting Banned', body: ['Follow this guide when you need a focused walkthrough. It explains the required checks, safe order of steps, common mistakes, and when you should stop and back up before continuing.'], cta: tutorialLinks[4] },
      { heading: 'Transfer WhatsApp Data', body: ['Follow this guide when you need a focused walkthrough. It explains the required checks, safe order of steps, common mistakes, and when you should stop and back up before continuing.'], cta: tutorialLinks[5] },
    ],
    faqs: [
      { q: 'Should I backup before every update?', a: 'Yes. A local backup is the easiest way to recover if the APK fails or your phone removes app data.' },
      { q: 'Can I fix verification without reinstalling?', a: 'Often yes. Check network signal, country code, SMS blocking apps, and the voice call option before reinstalling.' },
      { q: 'Is official WhatsApp safer?', a: 'For critical accounts, yes. GB WhatsApp is chosen for flexibility, while the official app is better for lower risk.' },
    ],
  },
  '/tutorials/install/': {
    navPage: 'tutorials',
    isGuide: true,
    guideBadge: 'Installation Tutorial',
    breadcrumbParent: { href: '/tutorials/', label: 'Tutorials' },
    breadcrumbLabel: 'Install Guide',
    title: 'How to Install GB WhatsApp APK (Step-by-Step Guide)',
    intro: 'GB WhatsApp is not available on Google Play, so Android users must install it manually with an APK file. This complete guide walks you through download, permissions, installation, verification, chat restore, and the most common errors users face during setup.',
    sections: [
      {
        step: '01',
        heading: 'What is Required Before Installation',
        iconSrc: require('@/assets/install/step-01-download.svg'),
        body: [
          'Before you install GB WhatsApp, confirm that your phone meets the basic requirements and that you are ready for a manual APK setup. Skipping these checks is one of the most common reasons installation fails or chats are lost later.',
          'If you are moving from official WhatsApp, prepare a backup first and avoid uninstalling the old app until you understand how chat restore will work on your device.',
        ],
        bullets: [
          'Android 5.0 or higher with enough free storage for the APK and future media files',
          'A stable Wi-Fi or mobile data connection for download and SMS verification',
          'The same phone number you plan to use inside GB WhatsApp',
          'A trusted APK source — avoid random mirror sites and modified repacks',
          'Optional but recommended: a recent local chat backup before switching apps',
        ],
        tip: 'Charge your phone above 50% before starting. Installation and first-time restore can take several minutes on slower devices.',
      },
      {
        step: '02',
        heading: 'Enable Unknown Sources on Android',
        iconSrc: require('@/assets/install/step-02-settings.svg'),
        body: [
          'Because GB WhatsApp is installed outside the Play Store, Android must allow APK installation from your browser or file manager. The exact menu name varies by brand, but the permission flow is similar on most modern phones.',
          'On Android 8.0 and above, unknown-source permission is granted per app, which means you must enable it for Chrome, Files, or whichever app opens the APK.',
        ],
        bullets: [
          'Open Settings → Security or Privacy → Install unknown apps',
          'Select the app you use to download or open APK files',
          'Turn on Allow from this source',
          'Return to the downloaded APK and try installation again if you previously saw a blocked message',
        ],
        tip: 'If you cannot find the option, search Settings for “Install unknown apps” or “Unknown sources”.',
      },
      {
        step: '03',
        heading: 'Download and Install the APK',
        iconSrc: require('@/assets/install/step-03-apk.svg'),
        body: [
          'Download the latest GB WhatsApp APK from a source you trust, then open the file from your notification panel or Downloads folder. Tap Install and wait until Android confirms the app was added successfully.',
          'If you already have an older GB WhatsApp build installed, you can usually install the new APK over it without deleting the app, as long as the package is compatible and signed consistently.',
        ],
        bullets: [
          'Download only one APK copy and verify the file size looks normal',
          'Tap the APK file, then confirm Install on the system prompt',
          'If prompted by Play Protect, review the warning and proceed only when you trust the source',
          'Do not open random cleaner or booster apps suggested by low-quality download pages',
        ],
        tip: 'After installation, check the app icon and version number before entering your phone number.',
      },
      {
        step: '04',
        heading: 'Verify Your Phone Number',
        iconSrc: require('@/assets/install/step-05-shield.svg'),
        body: [
          'Launch GB WhatsApp and enter your country code and phone number. WhatsApp-style verification usually sends a 6-digit SMS code, with a voice-call fallback if the text message does not arrive.',
          'Verification problems are often caused by weak signal, SMS filtering apps, or using a number that is still actively tied to another conflicting setup.',
        ],
        bullets: [
          'Double-check the country code and mobile number before requesting a code',
          'Wait at least 60–90 seconds before requesting another SMS',
          'Use the Call me option if SMS does not arrive after multiple attempts',
          'Temporarily disable spam blockers or SMS filter apps that may hide OTP messages',
        ],
        tip: 'If verification keeps failing, restart the phone and try again on a stable network before reinstalling.',
      },
      {
        step: '05',
        heading: 'Grant Permissions and Complete Setup',
        iconSrc: require('@/assets/install/step-06-whatsapp.svg'),
        body: [
          'During first launch, GB WhatsApp may ask for access to contacts, storage, notifications, microphone, and camera. These permissions are needed for normal messaging, media sharing, and voice notes.',
          'You can review or change permissions later in Android system settings, but blocking storage or notifications too early may cause missing media or delayed alerts.',
        ],
        bullets: [
          'Allow contact access if you want your address book to sync normally',
          'Allow storage access so photos, videos, and documents can be sent and saved',
          'Enable notifications to avoid missing messages in the background',
          'Review battery optimization settings if alerts later appear delayed',
        ],
        tip: 'On some phones, you need to exclude GB WhatsApp from aggressive battery saver modes for reliable notifications.',
      },
      {
        step: '06',
        heading: 'Restore Chats and Final Safety Checks',
        iconSrc: require('@/assets/install/step-06-whatsapp.svg'),
        body: [
          'If Android or GB WhatsApp detects an existing backup, follow the on-screen restore flow before using the app heavily. Restoring at setup is much easier than trying to recover chats after the database has already been overwritten.',
          'Once setup is complete, send a few test messages, check media download behavior, and confirm that your profile, privacy settings, and chats look correct.',
        ],
        bullets: [
          'Restore from local backup during setup when prompted',
          'Open a few old chats to confirm text history and media are intact',
          'Check Settings → Chats to confirm backup options are configured',
          'Update to the latest version regularly to reduce bugs and compatibility issues',
        ],
        tip: 'Keep a fresh backup after successful installation so updates and future transfers are safer.',
      },
    ],
    relatedLinks: buildPageLinks(['/tutorials/update/', '/tutorials/verification/', '/download/', '/tutorials/']),
  },
  ...createTutorialGuidePages(buildPageLinks),
  '/features/': {
    navPage: 'features',
    title: 'GB WhatsApp Features Hub',
    intro: 'Explore the GB WhatsApp features users usually care about most: privacy visibility, deleted messages, themes, and dual-account convenience.',
    sections: featureLinks.map((link) => ({
      heading: link.text,
      body: ['This feature guide explains what the option does, when it is useful, what limits to expect, and how to use it without creating avoidable privacy or account problems.'],
      cta: link,
    })),
  },
  ...createFeatureGuidePages(buildPageLinks),
  '/about-us/': {
    navPage: 'legal',
    title: 'About Us - Information & Tutorial Website',
    intro: 'Learn more about our informational website that provides guides and tutorials about GB WhatsApp. We are not affiliated with WhatsApp or its developers.',
    sections: [{ heading: 'About Us', body: [
      'We are an independent informational website that provides guides, tutorials, and educational content related to GB WhatsApp.',
      'Our goal is to help users understand how the application works, including installation, updates, features, and troubleshooting methods.',
      'We do not develop, distribute, or modify any software.',
      'We are not affiliated, associated, authorized, endorsed by, or in any way officially connected with WhatsApp LLC or its parent company.',
      'All content on this website is for informational and educational purposes only. Users are responsible for how they choose to use any information provided.',
    ] }],
  },
  '/contact-us/': {
    navPage: 'legal',
    title: 'Contact Us - Get in Touch',
    intro: 'Contact us for general inquiries about our informational GB WhatsApp guide website. We do not provide technical support or app development services.',
    sections: [{ heading: 'Contact Us', body: [
      'If you have any questions regarding our content or website, you can contact us via email.',
      'Please note that we do not provide technical support, software development, or direct assistance for installing or modifying any application.',
      'This website is strictly for informational and educational purposes only.',
      'We aim to respond to general inquiries as soon as possible.',
    ] }],
  },
  '/privacy-policy/': {
    navPage: 'legal',
    title: 'Privacy Policy - User Data & Cookies',
    intro: 'Read our privacy policy to understand how we handle cookies, analytics, and user data on our informational website.',
    sections: [{ heading: 'Privacy Policy', body: [
      'This Privacy Policy explains how we handle information when you visit our website.',
      'We may use cookies and analytics tools to improve user experience and understand website traffic.',
      'We may also use third-party services such as advertising networks or analytics providers.',
      'We do not collect personally identifiable information unless you voluntarily provide it through contact forms.',
      'We do not sell or share personal data with third parties.',
      'All data collected is used only for improving website performance and content quality.',
    ] }],
  },
  '/terms-conditions/': {
    navPage: 'legal',
    title: 'Terms & Conditions - Website Usage Policy',
    intro: 'Read the terms and conditions for using our informational website. All content is provided for educational purposes only.',
    sections: [{ heading: 'Terms & Conditions', body: [
      'By accessing this website, you agree to the following terms and conditions.',
      'All content is provided for informational and educational purposes only.',
      'We do not guarantee the accuracy, completeness, or reliability of any information provided.',
      'Users are responsible for how they use the information available on this website.',
      'We are not responsible for any losses, damages, or issues that may occur from the use of our content.',
      'We reserve the right to update or change these terms at any time without prior notice.',
    ] }],
  },
  '/disclaimer/': {
    navPage: 'legal',
    title: 'Disclaimer - Important Legal Notice',
    intro: 'This website is not affiliated with WhatsApp or its developers. All content is for informational and educational purposes only.',
    sections: [{ heading: 'Disclaimer', body: [
      'This website is an independent informational platform.',
      'We are not affiliated, associated, authorized, endorsed by, or in any way officially connected with WhatsApp LLC or its parent company.',
      'All product names, logos, and brands are property of their respective owners.',
      'The content provided on this website is for informational and educational purposes only.',
      'We do not develop, host, distribute, or modify any software mentioned on this site.',
      'Users are responsible for how they choose to use the information provided.',
      'We do not guarantee that any information on this website is complete, accurate, or up to date.',
    ] }],
  },
};

export const pageMeta = {
  '/download/': ['Download GB WhatsApp APK Latest Version', 'Download GB WhatsApp APK for Android with safety notes, app details, and installation guidance.', 'GB WhatsApp APK Download, GB WhatsApp'],
  '/tutorials/': ['GB WhatsApp Tutorials - Install, Update, Backup & Fix Guide', 'Explore complete GB WhatsApp tutorials including installation, update, backup, verification fix, ban prevention, and data transfer guides. Step-by-step solutions for all common issues.', 'GB WhatsApp tutorial'],
  '/tutorials/install/': ['How to Install GB WhatsApp APK (Step-by-Step Guide)', 'Learn how to install GB WhatsApp APK on Android safely. Includes setup steps, permissions, and common error fixes.', 'install GB WhatsApp, GB WhatsApp APK install, WhatsApp mod installation guide'],
  '/tutorials/update/': ['How to Update GB WhatsApp Without Losing Data', 'Step-by-step guide to update GB WhatsApp safely without losing chats or data. Includes backup tips and error fixes.', 'update GB WhatsApp, GB WhatsApp latest version, WhatsApp mod update'],
  '/tutorials/backup/': ['How to Backup and Restore GB WhatsApp Chats', 'Learn how to backup and restore GB WhatsApp chats using local storage methods. Keep your messages safe during updates or switching devices.', 'backup GB WhatsApp, restore WhatsApp chats, WhatsApp mod backup'],
  '/tutorials/verification/': ['How to Fix Verification Code Not Received in GB WhatsApp', 'Fix GB WhatsApp verification code not received issue with simple troubleshooting steps including SIM, network, and reinstall solutions.', 'verification code not received, GB WhatsApp OTP fix, WhatsApp verification issue'],
  '/tutorials/ban/': ['How to Avoid Getting Banned on GB WhatsApp', 'Learn practical habits that may reduce GB WhatsApp ban risk, including updates, normal messaging behavior, automation limits, and account warning steps.', 'GB WhatsApp ban, avoid WhatsApp ban, anti ban WhatsApp mod'],
  '/tutorials/transfer/': ['How to Transfer WhatsApp Data to GB WhatsApp', 'Step-by-step guide to transfer WhatsApp chats and data to GB WhatsApp safely without losing messages or media.', 'transfer WhatsApp to GB WhatsApp, migrate chats WhatsApp mod, WhatsApp data transfer'],
  '/features/': ['GB WhatsApp Features Hub', 'Explore useful GB WhatsApp features including hide online, anti delete messages, themes, and dual WhatsApp account setup.', 'GB WhatsApp features'],
  '/features/hide-online/': ['How to Hide Online Status in GB WhatsApp', 'Learn how to hide online status and last seen in GB WhatsApp for better privacy control and invisible chatting experience.', 'hide online WhatsApp, GB WhatsApp online status, last seen hide WhatsApp mod'],
  '/features/anti-delete/': ['How to Read Deleted Messages in GB WhatsApp (Anti Delete Feature)', 'Enable anti delete feature in GB WhatsApp to read deleted messages and view removed status updates easily.', 'anti delete WhatsApp, read deleted messages GB WhatsApp, WhatsApp mod features'],
  '/features/themes/': ['How to Customize Themes in GB WhatsApp', 'Change and customize GB WhatsApp themes easily. Personalize chat colors, fonts, and interface design.', 'GB WhatsApp themes, customize WhatsApp mod, WhatsApp UI change'],
  '/features/dual-whatsapp/': ['How to Use Dual WhatsApp on One Phone (GB WhatsApp)', 'Run two WhatsApp accounts on one device using GB WhatsApp. Simple guide to set up and manage dual WhatsApp.', 'dual WhatsApp, two WhatsApp accounts, GB WhatsApp dual account'],
  '/about-us/': ['About Us - Information & Tutorial Website', 'Learn more about our informational website that provides guides and tutorials about GB WhatsApp. We are not affiliated with WhatsApp or its developers.', 'GB WhatsApp information website'],
  '/contact-us/': ['Contact Us - Get in Touch', 'Contact us for general inquiries about our informational GB WhatsApp guide website. We do not provide technical support or app development services.', 'contact GB WhatsApp guide website'],
  '/privacy-policy/': ['Privacy Policy - User Data & Cookies', 'Read our privacy policy to understand how we handle cookies, analytics, and user data on our informational website.', 'privacy policy'],
  '/terms-conditions/': ['Terms & Conditions - Website Usage Policy', 'Read the terms and conditions for using our informational website. All content is provided for educational purposes only.', 'terms and conditions'],
  '/disclaimer/': ['Disclaimer - Important Legal Notice', 'This website is not affiliated with WhatsApp or its developers. All content is for informational and educational purposes only.', 'GB WhatsApp disclaimer'],
};
